import React from 'react';
import { withRouter } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';


const muiTheme = getMuiTheme({
  fontFamily: 'Open Sans',
});

const Logout = (props) => {

  return (
    <MuiThemeProvider muiTheme={muiTheme}>
      <a
        className={"logout-link"}
        style={{ cursor: "pointer", marginLeft: 15, color: '#90caf9' }}
        onClick={() => props.setAuthentication(false, undefined, () => {
          props.history.push('/');
          localStorage.removeItem('data');
        }
        )}>Odjavi se</a>
    </MuiThemeProvider >
  );
};
export default withRouter(Logout);



// WEBPACK FOOTER //
// ./src/Components/Logout/Logout.jsx